/**
 * @Author: Zewei
 * @Date:   2018-02-07T11:30:23+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T14:39:00+08:00
 */
 import _util from '../../utils/';

 const reportFormsService = {
     fetchMonthlyReports (params, resolve, reject) {
         _util.request({
             url: '/api/HREmployee/EmployeeMonthlyReport',
             params: params,
             success: resolve,
             error: reject
         })
     },
     exportMonthlyReports (params, resolve, reject) {
         _util.request({
             url: '/api/HREmployee/EmployeeMonthlyReportExport',
             params: params,
             success: resolve,
             error: reject
         })
     },
     fetchEmployeesReviewList (params, resolve, reject) {
         _util.request({
             url: '/api/HREmployee/EmployeeMonthlyReportDetail',
             params: params,
             success: resolve,
             error: reject
         })
     },
     exportEmployeesMonthlyReportDetail (params, resolve, reject) {
         _util.request({
             url: '/api/HREmployee/EmployeeMonthlyReportDetailExport',
             params: params,
             success: resolve,
             error: reject
         })
     },
}

export default reportFormsService;



// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/report-forms-service.js